module.exports = __webpack_public_path__ + "img/model.f4955331.png";